export default __webpack_public_path__ + "static/media/crud-redux-toolkit.13dc747e.PNG";